/** Turns a custom page's title into a URL-safe slug — lowercase,
 * non-alphanumerics collapsed to single hyphens, no leading/trailing
 * hyphen. Used both as the page's `siteContent`/`customPages` doc id and
 * its public URL segment (`/page/{slug}`). */
export function slugify(title) {
  return title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
